import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService } from '../../core/services/http/http.service';
import { API_ENDPOINTS } from '../../core/config/api.config';
import { environment } from '../../../environments/environment';
import type {
  ConfirmSubscriptionPaymentRequest,
  ConfirmSubscriptionPaymentResponse,
  InitiateSubscriptionPaymentRequest,
  InitiateSubscriptionPaymentResponse,
} from './models/subscription-payment.model';

type ApiResponse<T> = {
  data: T;
};

@Injectable({ providedIn: 'root' })
export class CpSubscriptionPaymentApiService {
  private readonly http = inject(HttpService);

  /** Admin monolith (platform Razorpay) — same routes as builder portal. */
  private platformBillingUrl(path: string): string {
    const base = (
      environment.platformBillingApiUrl ?? environment.apiUrl
    ).replace(/\/$/, '');
    const suffix = path.startsWith('/') ? path : `/${path}`;
    return `${base}${suffix}`;
  }

  initiate(
    body: InitiateSubscriptionPaymentRequest,
  ): Observable<InitiateSubscriptionPaymentResponse> {
    return this.http
      .post<ApiResponse<InitiateSubscriptionPaymentResponse>>(
        this.platformBillingUrl(API_ENDPOINTS.PLATFORM_BILLING_PAYMENT.INITIATE),
        body,
      )
      .pipe(map((response) => response.data));
  }

  confirm(
    body: ConfirmSubscriptionPaymentRequest,
  ): Observable<ConfirmSubscriptionPaymentResponse> {
    return this.http
      .post<ApiResponse<ConfirmSubscriptionPaymentResponse>>(
        this.platformBillingUrl(API_ENDPOINTS.PLATFORM_BILLING_PAYMENT.CONFIRM),
        body,
      )
      .pipe(map((response) => response.data));
  }
}
